import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import { Form } from 'react-bootstrap'

import moment from 'moment'
import 'moment/locale/es'

// import { labelPrivilegio } '../services/funcionesPublicas'
import { labelPrivilegio } from '../../services/funcionesPublicas'

const Estructura = () =>{

  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


      const [ uuid_sucursal, setUUIDSucursal ] = useState<any>("NO_SELECCIONADA")
      const [ estructura, setRegistro ] = useState<any>({
        sucursal : { nombre_sucursal : "", uuid : "" },
        estructura : [{asesores:[]}]
      })

      const cargar = async (uuid_sucursal:string) =>{
        try{
            let res = await RequestService.getEndPoint(`estructura/${uuid_sucursal}`)
            setRegistro(res.data)
            setUUIDSucursal(res.data.sucursal.uuid)

        }
        catch(e){
          toast.error('Problemas cargando')
          toast.error(JSON.stringify(e))
        }
      }

      React.useEffect(() => {
        cargar(uuid_sucursal)
    cargarSucursales()
      }, []);



  const [ sucursales, setSucursales ] = useState<any>([])
  const cargarSucursales = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`sucursales`)
      setSucursales(response.data)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }





      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Estructura</h4>
                    <hr/>


                    <div className="row">
                      <div className="col-3">
                        
                          <div className="mb-4">
                            <label className="form-label">Lista de Sucursales</label>
                            {
                              sucursales.map((sucursal:any)=>

                                  <Form.Check type="radio" key={ Math.random().toString(36).substr(2, 9) } id={ Math.random().toString(36).substr(2, 9) } label={sucursal.nombre_sucursal} checked={uuid_sucursal===sucursal.uuid} onChange={(e:any)=>{setUUIDSucursal(sucursal.uuid);cargar(sucursal.uuid)}} />

                                )
                            }
                          </div>




                    {
                      // JSON.stringify(sucursales)
                    }



                      </div>
                      <div className="col-9">







                          {  (!envio_server) && (

                              <>

                                <small>Sucursal</small>
                                <h4>{estructura.sucursal.nombre_sucursal}</h4>

                              {
                                // JSON.stringify(estructura.sucursal)
                              }

                              {
                                estructura.estructura.length === 0 && (

                                      <div className="alert alert-secondary">
                                          <i className="fa fa-warning" /> Esta sucursal no cuenta con gerentes
                                      </div>

                                  )
                              }

                              {
                                estructura.estructura.length > 0 && (

                                                                          <table className="table">
                                                                            <thead style={{"fontSize":8}}>
                                                                              <tr>
                                                                                <th scope="col">Rol</th>
                                                                                <th scope="col">Nombre</th>
                                                                                <th scope="col">Usuario </th>
                                                                                <th scope="col">Celular </th>
                                                                                <th scope="col"> </th>
                                                                              </tr>
                                                                            </thead>
                                                                            <tbody>



                                                                              {
                                                                                estructura.estructura.map( gerente => 

                                                                                    <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                                                                            <tr className="table-success" key={ Math.random().toString(36).substr(2, 9) }>
                                                                                              <td className="v" style={{width:150}}>
                                                                                                <p className="nm"><small>{labelPrivilegio(gerente.rol)}</small></p>
                                                                                              </td>
                                                                                              <td className="v" style={{fontSize:12}}><b>{gerente.nombres}</b> <small>{gerente.paterno} {gerente.materno}</small></td>
                                                                                              <td className="v" style={{fontSize:12}}>  <b>{gerente.username}</b></td>
                                                                                              <td className="v" style={{fontSize:12}}>  <small>{gerente.celular}</small></td>
                                                                                                            <td className="v" style={{width:150}}>
                                                                                                              <p className="nm"><small>
                                                                                                                {gerente.asesores.length} { gerente.asesores.length > 1 ? 'ASESORES' : 'ASESOR' }
                                                                                                              </small></p>
                                                                                                            </td>
                                                                                            </tr>



                                                                                            {
                                                                                              gerente.ver_asesores && (
                                                                                                    <>
                                                                                                      {
                                                                                                        gerente.asesores.map( asesor => 

                                                                                                            <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                                                                                                    <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                                                                      <td className="v" style={{width:150}}>
                                                                                                                        <p className="nm"><small>{labelPrivilegio(asesor.rol)}</small></p>
                                                                                                                      </td>
                                                                                                                      <td className="v" colSpan={1} style={{fontSize:12}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <b>{asesor.nombres}</b> <small>{asesor.paterno} {asesor.materno}</small></td>
                                                                                                                      <td className="v" colSpan={1} style={{fontSize:12}}><b>{asesor.username}</b></td>
                                                                                                                      <td className="v" colSpan={1} style={{fontSize:12}}><small>{asesor.celular}</small></td>
                                                                                                                      <td className="v" colSpan={1} style={{fontSize:12}}><small> </small></td>
                                                                                                                    </tr>




                                                                                                            </React.Fragment>

                                                                                                          )
                                                                                                      }
                                                                                                    </>
                                                                                              )
                                                                                            }



                                                                                    </React.Fragment>

                                                                                  )
                                                                              }

                                                                            </tbody>
                                                                          </table>

                                  )
                              }




                                   {
                                    // JSON.stringify(estructura)
                                   }

                              </>

                           )}

                          {  envio_server && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}




                    {
                      // JSON.stringify(estructura)
                    }
                        
                      </div>
                    </div>


                    
                </div>
              </div>

            </div>

          </>

      );
  

}

export default Estructura
